import React from 'react';
import { Link } from 'react-router-dom';
import { DollarSign, Clock, MapPin, AlertCircle, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { fees } from '../mock';
import PricingCard from '../components/sections/PricingCard';
import PageMeta from '../components/sections/PageMeta';

const Pricing = () => (
  <div className="min-h-screen">
    <PageMeta
      title="Pricing & Fees | Bring-A-Nurse Senior Companion, Fuquay Varina NC"
      description="Transparent pricing for senior nurse companion services in Fuquay Varina, Holly Springs, Apex, and Cary. Fair, up-front rates with no hidden fees."
      path="/pricing"
    />
    <section className="bg-gradient-to-br from-blue-50 to-white py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto text-center">
        <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
          Fees & Services
        </h1>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          Our prices are fair, up-front, and transparent, with no hidden fees .
        </p>
      </div>
    </section>

    <section className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          <PricingCard
            icon={DollarSign}
            price={fees.consultation.price}
            unitLabel="Consultation"
            listTitle="What's Included:"
            items={fees.consultation.details}
            ctaLabel="Get Started"
          />

          <PricingCard
            icon={Clock}
            price={fees.officeVisit.price}
            unitLabel={fees.officeVisit.unit}
            note={fees.officeVisit.note}
            listTitle="On the Day of Your Visit:"
            items={fees.officeVisit.arrangement}
            bulletIcon={ArrowRight}
          />
        </div>

        <Card className="bg-amber-50 border-2 border-amber-200">
          <CardContent className="p-8">
            <div className="flex items-start space-x-4">
              <AlertCircle className="w-6 h-6 text-amber-600 flex-shrink-0 mt-1" />
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Important Information</h3>
                <p className="text-gray-700">{fees.importantNote}</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>

    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <Card className="border-2">
          <CardContent className="p-8 space-y-6">
            <div className="flex items-center space-x-3">
              <div className="bg-blue-100 rounded-full p-3">
                <MapPin className="w-6 h-6 text-blue-600" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Service Area</h3>
            </div>
            <p className="text-lg text-gray-700">
              Proudly serving: <span className="font-semibold">Fuquay Varina, Holly Springs, Apex, and Cary</span>
            </p>
            <div className="bg-blue-50 rounded-lg p-4">
              <p className="text-gray-700">
                <span className="font-semibold">Note:</span> If need to attend appointments outside this service area, there will be an added cost.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>

    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-blue-600 to-blue-700 text-white">
      <div className="max-w-4xl mx-auto text-center space-y-8">
        <h2 className="text-3xl sm:text-4xl font-bold">
          Ready to Get Started?
        </h2>
        <p className="text-xl text-blue-100">
          Schedule your consultation today and experience compassionate, professional nursing support
        </p>
        <Link to="/contact">
          <Button size="lg" className="bg-white text-blue-600 hover:bg-blue-50 text-lg px-8 py-6">
            Book Your Consultation
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>
        </Link>
      </div>
    </section>
  </div>
);

export default Pricing;
